<template>
  <v-menu
    bottom
    left
    min-width="200"
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-avatar
        class="elevation-2 ml-5"
        size="50"
        v-bind="attrs"
        v-on="on"
      >
        <img :src="$auth.user.picture">
      </v-avatar>
    </template>

    <v-list
      :tile="false"
      flat
      nav
    >
      <template v-for="(p, i) in profile">
        <v-divider
          v-if="p.divider"
          :key="`divider-${i}`"
          class="mb-2 mt-2"
        />

        <app-bar-item
          v-else
          :key="`item-${i}`"
          :to="p.to"
        >
          <v-icon
            class="mr-5"
            v-text="p.icon"
          />
          <v-list-item-title v-text="p.title" />
        </app-bar-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
  import { sync } from 'vuex-pathify'

  export default {
    name: 'DefaultAccount',

    data: () => ({
      profile: [
        { title: 'Profile', to: '/Profile/', icon: 'mdi-account' },
        { divider: true },
        { logout: true, title: 'Log out', to: '/logout', icon: 'mdi-logout' },
      ],
    }),
    computed: {
      ...sync('user', [
        'dark',
        'name',
        'nickname',
        'firstName',
        'lastName',
      ]),
      ...sync('app', [
        'mini',
      ]),
    },
    created () {
      const metadata = this.$auth.user['https://conductor.systems_user_metadata']
      this.dark = metadata.theme === 'dark'
      this.$vuetify.theme.isDark = this.dark
      this.name = this.$auth.user.name
      this.nickname = this.$auth.user.nickname
      this.firstName = this.$auth.user.given_name
      this.lastName = this.$auth.user.family_name
      this.mini = metadata.mini === 'true'
    },
  }
</script>
